import { Injectable } from '@angular/core';


@Injectable()
export class CommonAffixService {
  findCommonPrefix(strings: string[] | undefined): string {
    if (!strings || strings.length === 0) return '';

    const maxIterations = strings[0].length;

    let commonPrefix = '';
    for (let i = 1; i <= maxIterations; i++) {
      const prefix = strings[0].slice(0, i);
      if (strings.every((str) => str.startsWith(prefix))) {
        commonPrefix = prefix;
      } else {
        break;
      }
    }
    return commonPrefix;
  }

  findCommonSuffix(strings: string[] | undefined): string {
    if (!strings || strings.length === 0) return '';

    const maxIterations = strings[0].length;

    let commonSuffix = '';
    for (let i = 1; i <= maxIterations; i++) {
      const suffix = strings[0].slice(-i);
      if (strings.every((str) => str.endsWith(suffix))) {
        commonSuffix = suffix;
      } else {
        break;
      }
    }
    return commonSuffix;
  }
}
